import React, { useState } from 'react';
// import { observer } from 'src/utils/mobx-react';
import { observer } from 'mobx-react-lite';
import { AutomationTradingState, AutomationItemType } from 'src/components/AutomationTrading/AutomationTrading';
import {
    AutomationItemWrapper,
    ControlsWrapper,
    ErrorWrapper,
    HistoryHeader,
    NameWrapper,
    SchedulerWrapper,
    HistoryHeaderCell,
    ButtonsWrapper,
    ActionsWrapper,
    ScheduleButton,
    DisabledText,
    EnabledText,
    ScheduleText,
} from 'src/components/AutomationTrading/AutomationItem/AutomationItem.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { Filters } from 'src/components/AutomationTrading/AutomationItem/ItemFilters';
import { Commands } from 'src/components/AutomationTrading/AutomationItem/ItemCommands';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { Toggle } from 'src/domains/layouts/shared/toggle/Toggle';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { AutomationItemState } from 'src/components/AutomationTrading/AutomationItem/AutomationItem.state';
import { HistoryItem } from 'src/components/AutomationTrading/AutomationItem/HistoryItem';
import { AutomationPopupState } from 'src/components/AutomationTrading/AutomationPopup/AutomationPopup.state';
import { ItemOptionalFilter } from 'src/components/AutomationTrading/AutomationItem/ItemOptionalFilter';
import {
    AutotraderAutomationFilterParametrizedType,
    AutotraderAutomationFilterType,
} from 'src/api_openapi/v2/automations/schemas';
import { CronComponent } from './CronComponent';

function getParametrizedFilter(
    allFilters: Array<AutotraderAutomationFilterType>
): AutotraderAutomationFilterParametrizedType | null {
    for (const filter of allFilters) {
        if (filter.kind === 'parametrized') {
            return filter;
        }
    }
    return null;
}

export type AutomationItemPropsType = {
    automationItem: AutomationItemType;
    automationState: AutomationTradingState;
    popupState: AutomationPopupState;
};

export const AutomationItem = observer((props: AutomationItemPropsType) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new AutomationItemState(props, appState));
    console.log('props.automationItem.schedule ', props.automationItem.schedule);
    return (
        <AutomationItemWrapper>
            {state.changeNameInputActive === true ? (
                <>
                    <Input formInputState={state.nameInputState} />
                    <Button
                        size='regular'
                        onClick={state.saveName}
                    >
                        Save name
                    </Button>
                </>
            ) : (
                <NameWrapper onClick={state.changeNameActive}>{props.automationItem.name}</NameWrapper>
            )}
            <div>
                <h5>Schedule (UTC time)</h5>
                <ScheduleText>
                    The scheduler is
                    {props.automationItem.schedule === undefined ? (
                        <DisabledText> disabled</DisabledText>
                    ) : (
                        <EnabledText> enabled</EnabledText>
                    )}
                </ScheduleText>

                <SchedulerWrapper>
                    <CronComponent
                        setError={state.setError}
                        setValue={state.setValue}
                        value={state.scheduleValue}
                    />
                    <ScheduleButton
                        size='small'
                        onClick={state.onChangeSchedulerActive}
                    >
                        Save Schedule
                    </ScheduleButton>
                    <ScheduleButton
                        size='small'
                        onClick={state.onResetScheduler}
                    >
                        Reset and turn off
                    </ScheduleButton>

                    {state.error === null ? null : <ErrorWrapper>{state.error}</ErrorWrapper>}
                </SchedulerWrapper>
            </div>
            <ActionsWrapper>
                <h5>Action for: {state.typeOfAction}</h5>
                <div>
                    {props.automationItem.actions.map((action) => {
                        // const actionType = state.typeOfAction;

                        if (action.kind === 'events') {
                            const filters = action.events.filters;
                            const command = action.events.command;
                            const optionalFilter = getParametrizedFilter(filters);

                            return (
                                <>
                                    <Filters
                                        filters={filters}
                                        automationItem={props.automationItem}
                                    />
                                    {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
                                    {optionalFilter === undefined ? null : (
                                        <>
                                            <h5>Parametrized Action</h5>
                                            <ItemOptionalFilter
                                                filters={optionalFilter}
                                                automationItemState={state}
                                            />
                                        </>
                                    )}
                                    <Commands commands={command} />
                                </>
                            );
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                        } else if (action.kind === 'markets') {
                            const filters = action.markets.filters;
                            const command = action.markets.command;
                            const optionalFilter = getParametrizedFilter(filters);
                            return (
                                <>
                                    <Filters
                                        filters={filters}
                                        automationItem={props.automationItem}
                                    />
                                    {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
                                    {optionalFilter === undefined ? null : (
                                        <>
                                            <h5>Parametrized Action </h5>
                                            <ItemOptionalFilter
                                                filters={optionalFilter}
                                                automationItemState={state}
                                            />
                                        </>
                                    )}
                                    <Commands commands={command} />
                                </>
                            );
                        }

                        return null;
                    })}
                </div>
            </ActionsWrapper>
            <ControlsWrapper>
                <ButtonsWrapper>
                    <Button
                        size='regular'
                        onClick={state.runAutomation}
                    >
                        Run now
                    </Button>
                    Max events per run: {props.automationItem.limit}
                </ButtonsWrapper>

                <Toggle
                    label='Active automat'
                    toggleActive={state.onChangeItemActive}
                    isActive={props.automationItem.active}
                    isDisabled={false}
                />
            </ControlsWrapper>
            <div>
                <h5>History:</h5>
                <table>
                    <HistoryHeader>
                        <HistoryHeaderCell>Id</HistoryHeaderCell>
                        <HistoryHeaderCell>User Id</HistoryHeaderCell>
                        <HistoryHeaderCell>Events Info</HistoryHeaderCell>
                        <HistoryHeaderCell>Created</HistoryHeaderCell>
                        <HistoryHeaderCell>State</HistoryHeaderCell>
                    </HistoryHeader>

                    {state.runsHistory !== null &&
                        state.runsHistory.items.map((item, index) => (
                            <HistoryItem
                                key={`${index}-${item.id}`}
                                item={item}
                                onOpenPopup={props.popupState.open}
                            />
                        ))}
                </table>
            </div>
        </AutomationItemWrapper>
    );
});
